const CACHE_KEY = 'scoreSettingListCache';
import scoresModule from "../scores-module";

scoresModule
  .factory('scoreSettingsService', ($http, $q, cacheService, $cacheFactory) => {
  var failureCount = 0;
  var accountSelectionDetailsPromise = null;

  let getScoreSettingsCache = () => {
    const cache = $cacheFactory.get(CACHE_KEY);
    if (!cache) {
      return $cacheFactory(CACHE_KEY, { created: Date.now() });
    } else {
      if (Date.now() - cache.info().created > 5000) {
        cache.destroy();
        return $cacheFactory(CACHE_KEY, { created: Date.now() });
      } else {
        return cache;
      }
    }
  };
  var invalidate = (resp) => { $cacheFactory.get(CACHE_KEY).destroy(); return resp; }

  var self = {
    getScoreSets() {
      return $http.get('/v5/scores/config', { cache: getScoreSettingsCache() }).then(resp => resp.data);
    },
    createScoreSet(scoreSet){
      return $http.post('/v5/scores/config', scoreSet).then(invalidate).then(resp => resp.data);
    },
    updateScoreSet(scoreSet){
      return $http.put('/v5/scores/config', scoreSet).then(invalidate).then(resp => resp.data);
    },
    deleteScoreSet(scoreConfigId){
      return $http.delete(`/v5/scores/config/${scoreConfigId}`).then(invalidate).then(resp => resp);
    }
  };

  return self;
});
